import { SimpleDialog } from '@colonist/ui';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
export const showSimpleDialog = mountDialogUIReactComponent(SimpleDialog);
